import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { getCookie } from 'common/util/cookie'
import displayMode from 'common/util/displayMode'

const App = () => {
    const footerType = window.FOOTER_TYPE || ''
    const [user, setUser] = useState(null)

    useEffect(() => {
        userInfo().then(res => {
            setUser(res.data)
        })
    }, [])

    const setDisplayMode = () => {
        let display = new displayMode('pc');
        display.set();
    }

    const userInfo = () => {
        const url = `${process.env.REACT_APP_API_URL}/front/v2/user/info`
        const auth_token = getCookie('auth_token')
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization'
        }
        return axios.post(url, {auth_token}, config)
    }

    if (footerType === 'simple') return <></>
    return (
        <div className="footer_inner_wrap">
            <div className="footer_inner_button_group">
                <a href={user?.isLogin ? `${process.env.REACT_APP_API2_URL}/logout` : `${process.env.REACT_APP_SSO_URL}`} className="footer_link_btn">
                    {user?.isLogin ? '로그아웃' : '로그인'}
                </a>
                <button type="button" onClick={setDisplayMode} className="footer_link_btn">PC버전</button>
            </div>
            <div className="footer_inner_article">
                <div className="footer_inner_title">행복쇼핑 주식회사 사업자 정보</div>
                <div className="footer_inner_address">
                    <p>대표이사 : 강공승, 좌옥희</p>
                    <p>개인정보관리책임자 : 김기범(purity@pping.kr)</p>
                    <p>사업자등록번호 : 105-87-89183</p>
                    <p>통신판매번호 : 제 2023-서울양천-1680 호</p>
                    <p>(07997) 서울시 양천구 목동동로 293, 1동 2002~3호</p>
                    <p>고객센터 : 1600-4602 ㅣ 팩스 : 0505-300-4602</p>
                </div>
            </div>
            <div className="footer_inner_fnb">
                <a href={process.env.REACT_APP_CO_URL}>회사소개</a>
                <a href={`${process.env.REACT_APP_CO_URL}/recruit/apply`}>인재채용</a>
                <a href={`${process.env.REACT_APP_HELP_URL}/qna/write`}>입점제휴문의</a>
                <a href={`${process.env.REACT_APP_WWW_URL}/policy/service`}>이용약관</a>
            </div>
        </div>
    )
}

export default App



// WEBPACK FOOTER //
// ./src/m_footer/layouts/app/index.js